import { render, staticRenderFns } from "./localMailHome.vue?vue&type=template&id=d78d7552&"
import script from "./localMailHome.vue?vue&type=script&lang=js&"
export * from "./localMailHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports